import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-datenschutz',
  imports: [],
  templateUrl: './datenschutz.html',
  styleUrl: './datenschutz.css',
})
export class Datenschutz implements OnInit {

  ngOnInit() {
    // Scroll to top when component loads, especially important for mobile devices
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
